export function deleteSelectedElement(selectedEl: HTMLElement | null): HTMLElement | null {
    if (!selectedEl) return null;

    const parent = selectedEl.parentElement;
    if (!parent) return null;

    parent.removeChild(selectedEl);
    return null; // artık seçili yok
}